import styled from 'styled-components';
import { Box } from '@rsos/base-components';

export const Wrapper = styled(Box).attrs({
  p: 20,
  width: 315,
  borderRadius: 5,
  color: 'primaryText',
  flow: 10,
  height: 'fit-content',
  border: '1px solid',
  borderColor: 'heavyLineOutline',
})``;

export const SoundBlock = styled(Box).attrs({
  bg: 'foreground',
  horizontal: true,
  p: 10,
  justify: 'space-between',
  align: 'center',
  height: 45,
  borderRadius: 5,
  border: '1px solid',
  borderColor: 'heavyLineOutline',
})``;
